import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\text-to-speech\\text-to-speech-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\hooks\\providers\\wavesurfer-provider.tsx");
